import { render, staticRenderFns } from "./verCodigos.vue?vue&type=template&id=3b9cd2b8"
import script from "./verCodigos.vue?vue&type=script&lang=js"
export * from "./verCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports